import React, { useEffect, useRef, useState } from "react";
import SEO from "../components/SEO";
import "./Gallery.css";

import img1 from "../assets/gallery1.jpeg";
import img2 from "../assets/gallery2.jpeg";
import img3 from "../assets/gallery3.jpeg";
import img4 from "../assets/gallery4.jpeg";
import img5 from "../assets/gallery5.jpeg";
import img6 from "../assets/gallery6.jpeg";
import img7 from "../assets/gallery7.jpeg";
import img8 from "../assets/gallery8.jpeg";
import img9 from "../assets/gallery9.jpeg";
import img10 from "../assets/gallery10.jpeg";
import img11 from "../assets/gallery11.jpeg";
import img12 from "../assets/gallery12.jpeg";
import img13 from "../assets/gallery13.jpeg";

import AOS from "aos";
import "aos/dist/aos.css";

function Gallery() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeDesktopCard, setActiveDesktopCard] = useState(null);

  const normalGalleryImages = [img1, img2, img3, img4, img5, img6];
  const effectGalleryImages = [img7, img8, img9, img10, img11, img12, img13];

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
      offset: 100,
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.35,
      }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  const centerIndex = (effectGalleryImages.length - 1) / 2;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % effectGalleryImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + effectGalleryImages.length) % effectGalleryImages.length
    );
  };

  const nextDesktop = () => {
    setActiveDesktopCard((prev) =>
      prev === null ? 0 : (prev + 1) % effectGalleryImages.length
    );
  };

  const prevDesktop = () => {
    setActiveDesktopCard((prev) =>
      prev === null
        ? effectGalleryImages.length - 1
        : (prev - 1 + effectGalleryImages.length) % effectGalleryImages.length
    );
  };

  return (
    <>
    <SEO
      title="Gallery | SIP Abacus Malkajgiri Photos & Events"
      description="Browse the SIP Abacus Malkajgiri gallery showcasing classroom activities, student achievements, abacus competitions & events. See how children learn and grow with our abacus programs in Malkajgiri, Hyderabad."
      keywords="SIP Abacus gallery, abacus classroom photos, SIP Abacus Malkajgiri images, abacus student achievements, abacus competition photos, kids learning abacus, abacus events Hyderabad, SIP Abacus activities, student success stories, abacus class pictures Malkajgiri, children learning mental arithmetic, abacus training gallery"
      canonicalPath="/gallery"
    />
    <section className="page-section gallery" ref={sectionRef}>
      <div className="container">
        <h1 className="page-title" data-aos="fade-up">
          Gallery
        </h1>

        <h2 className="page-subtitle" data-aos="fade-up" data-aos-delay="100">
          Moments of learning and achievement
        </h2>

        <div className="normal-gallery-grid">
          {normalGalleryImages.map((img, index) => (
            <div
              className="normal-gallery-card"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <img src={img} alt={`Gallery ${index + 1}`} />
            </div>
          ))}
        </div>

        <div
          className={`deck-wrapper ${isVisible ? "spread" : ""}`}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <button
            className="deck-arrow deck-arrow-left"
            onClick={prevDesktop}
            aria-label="Previous image"
          >
            &#10094;
          </button>

          <div
            className={`deck-container ${
              activeDesktopCard !== null ? "deck-has-active" : ""
            }`}
          >
            {effectGalleryImages.map((img, index) => (
              <div
                className={`gallery-card ${
                  activeDesktopCard === index ? "manual-active" : ""
                }`}
                key={index}
                style={{
                  "--i": index,
                  "--offset": index - centerIndex,
                }}
                onMouseEnter={() => setActiveDesktopCard(index)}
                onMouseLeave={() => setActiveDesktopCard(null)}
                data-aos="flip-left"
                data-aos-delay={index * 100}
              >
                <img src={img} alt={`Effect Gallery ${index + 7}`} />
              </div>
            ))}
          </div>

          <button
            className="deck-arrow deck-arrow-right"
            onClick={nextDesktop}
            aria-label="Next image"
          >
            &#10095;
          </button>
        </div>

        <div className="gallery-mobile" data-aos="fade-up" data-aos-delay="300">
          <div className="mobile-carousel">
            <button
              className="carousel-btn carousel-btn-prev"
              onClick={prevSlide}
              aria-label="Previous image"
            >
              &#10094;
            </button>

            <div className="mobile-carousel-track">
              <div
                className="mobile-carousel-slider"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {effectGalleryImages.map((img, index) => (
                  <div className="mobile-card" key={index}>
                    <img src={img} alt={`Effect Gallery ${index + 7}`} />
                  </div>
                ))}
              </div>
            </div>

            <button
              className="carousel-btn carousel-btn-next"
              onClick={nextSlide}
              aria-label="Next image"
            >
              &#10095;
            </button>
          </div>

          <div className="carousel-dots">
            {effectGalleryImages.map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
    </>
  );
}

export default Gallery;